import React, { Component } from "react";
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import axios from 'axios';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { Bar } from "react-chartjs-2";
import stats1 from './images/yesterday-present.png';
import stats2 from './images/no-of-students.png';
import attndnceIcon from './images/attendance.png';
import RegisterIcon from './images/registration.png';
import yespreIcon from './images/yesterday-present.png';
import AlertsIcon from './images/Alerts.png';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import Select from '@mui/material/Select';
import Topperlist from "./Topperlist";
import payment from './images/payment-history.png';
import FormControl from '@mui/material/FormControl';
import ParentPassword from "./ParentPassword";
export default class Dashboard extends Component 
{
	
	constructor(props) 
	  {
			super();

			this.state = {yesatdncecnt:0,parentcnt:1,open:false,errormessage:'',studcnt:0,prevpage:0,dataarr:[],redirect:false,pagename:'',notifycnt:0,notifyarray:[],rowsPerPage:10,page: 0 ,
			batch:'',feebalance:0,studcountdata:[],feepayment:[],Branchdata:[],branchid:'',branchlabel:'',branch:'',}
	   this.escParentphFunction = this.escParentphFunction;
	   
	   }
	  myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val}, () => {
    if (nam === "branchid") {
     
      this.StudentsClasswisecount(); 
     
      
  
    }
  });
 
} 
getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

	componentWillMount() { 
localStorage.setItem("pageactive","1")


		
	if(localStorage.getItem("MMCuserid")===null)
	{
		this.setState({
							redirect: true,
							pagename:'/Login'
						  }) 
		

	}
	
	if(localStorage.getItem("MMCrole")==="1"){
	this.BranchBind();
	
	}
	localStorage.removeItem("MMEdSrId")
					  
			localStorage.removeItem("MMCSRId")
		localStorage.removeItem("MMCsaid")			  
						  		let search = window.location.href;
let strmsg = this.getParameterByName('msg',search);
	if(strmsg==="1")
	{
			this.setState({
							open: true,
							errormessage:'Please Select Student/ Register Student'
						  }) 
	}
	if(strmsg==="2")
	{
			this.setState({
							open: true,
							errormessage:'Please Select Student/ Admit the Student'
						  }) 
	}
	localStorage.setItem("page",this.state.rowsPerPage)
	 document.addEventListener("keydown", this.escParentphFunction, false);

  
		//this.StatsCountApicall();
		if(localStorage.getItem("MMCrole")!=="1"){
			 this.StatsCountApicall(); 
 
      this.BirthdayAlerts();
      
		}
}
	
		componentWillUnmount(){
    document.removeEventListener("keydown", this.escParentphFunction, false);
	
  } 
  
  BranchBind()
{
	axios.get(Serverurl+'ajaxbranch.php?action=getall')
       .then(resp => { 		
			if(resp.data.length>0){
				let strbrid=resp.data[0].br_id
				this.setState({
						Branchdata:resp.data},()=>{
							
						 let branchFromApi = this.state.Branchdata.map(row => {
                          
          return {value: row.br_id, display:row.br_title}
        });	
		 this.setState({branchid:strbrid,
          Branchdata: [{value: '0', display: 'Select Branch'}].concat(branchFromApi)
        },()=>{
			
			this.StudentsClasswisecount(); 
 
      this.BirthdayAlerts();
			
		});
							
						}) 
			
	 }
	 
	 
	   }) 

} 
  BirthdayAlerts()
  {
	  
	 
					
		axios.get(Serverurl+'ajaxstudentregistration.php?action=birthdayalerts')
       .then(resp => { 	
	   
	   axios.get(Serverurl+'ajaxnotifications.php?action=getdate')
       .then(resp => { 	
	   if(resp.data===1){
				axios.get(Serverurl+'ajaxnotifications.php?action=notifyalert&no_year_id='+localStorage.getItem("MMCyearid"))
					   .then(resp => {
								axios.get(Serverurl+'ajaxfeepayments.php?action=feealert')
													   .then(resp => { 					
															})	
						   
							})	
	   }							
			})	
	})	
			
  }
  
  
	StatsCountApicall()
	{
		axios.get(Serverurl+'ajaxattendance.php?action=dashboardlist&ad_br_id='+localStorage.getItem("MMCbranchid"))
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({yesatdncecnt:resp.data[0]["attencnt"],studcnt:resp.data[0]["stucnt"]});
			}
			else{
				this.setState({yesatdncecnt:0,studcnt:0});
			}
			this.NotificationApicall(this.state.page,this.state.rowsPerPage);
			
	   });
	
	}
	StudentsClasswisecount()
	{
		axios.get(Serverurl+'ajaxstudentregistration.php?action=dasboardstudcount&sa_year_id='+localStorage.getItem("MMCyearid")+'&branchid='+this.state.branchid)
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({studcountdata:resp.data});
			}
			else{
				this.setState({studcountdata:[]});
			}
			if(localStorage.getItem("MMCrole")!=="1")
		{
			this.StatsCountApicall();
		}else{
			
			this.NotificationApicall(this.state.page,this.state.rowsPerPage);
		}
	   });
	
	}
	
	FeebalanceApicall()
	{
		let strbranch=localStorage.getItem("MMCbranchid");
		if(localStorage.getItem("MMCrole")==="1")
		{
			strbranch=this.state.branchid;
		}
		axios.get(Serverurl+'ajaxfeepayments.php?action=dashboardfeebalance&bc_br_id='+strbranch+'&yearid='+localStorage.getItem("MMCyearid"))
     .then(resp => { 		
			if(resp.data.length>0){
				this.setState({feebalance:resp.data[0].balance});
			}else{
				this.setState({feebalance:0});
			}
			//this.StudentAttendanceGraphApicall();
	   });
	
	}
	NotificationApicall(page,rowsPerPage)
	{let strbranch=localStorage.getItem("MMCbranchid");
		if(localStorage.getItem("MMCrole")==="1")
		{
			strbranch=this.state.branchid;
		}
		axios.get(Serverurl+'ajaxnotifications.php?action=listbranch&no_year_id='+localStorage.getItem("MMCyearid")+'&no_branchid='+strbranch+'&index='+page+'&maxrecrd='+rowsPerPage)
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({notifyarray:resp.data,notifycnt:resp.data[0].count});
			}else{
				this.setState({notifyarray:[],notifycnt:0});
			}
			
	   });
	   //this.FeebalanceApicall();
	  this.StudentAttendanceGraphApicall();
		
	}
	
	StudentAttendanceGraphApicall = () => {
		let strbranch=localStorage.getItem("MMCbranchid");
		if(localStorage.getItem("MMCrole")==="1")
		{
			strbranch=this.state.branchid;
		}
		
		

  axios.get(Serverurl + 'ajaxattendance.php?action=attgraph&yearid='+localStorage.getItem("MMCyearid")+'&ad_br_id=' + strbranch)
    .then(resp => {
      if (resp.data && resp.data.length > 0) {
        const chartData = resp.data;

        const labels = chartData.map(row => row.tc_title);
        const attendanceData = chartData.map(row =>
          parseFloat(row.attendance_percent || 0)
        );

        const dataForChart = {
          labels: labels,
          datasets: [
            {
              label: 'Attendance (%)',
              data: attendanceData,
              backgroundColor: '#c0a2ec',
              borderColor: '#a684e3',
              borderWidth: 1,
              hoverBackgroundColor: '#d1b3ff',
              hoverBorderColor: '#a684e3',
            },
          ],
        };

        this.setState({
          dataarr: dataForChart
        });
      } else {
        this.setState({
          dataarr: { labels: [], datasets: [] }
        });
      }
    })
    .catch(error => {
      console.error("Attendance graph API error:", error);
      this.setState({
        dataarr: { labels: [], datasets: [] }
      });
    });
};
	
	
	
	

handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    },()=>{this.NotificationApicall(this.state.page, localStorage.getItem("page"))});
   
 
   
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)


    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{this.NotificationApicall(this.state.page, localStorage.getItem("page"))}); 
	
	
  };
escParentphFunction= (event) => {
	 var self=this; 
        let nam = event.target.name;
        let val = event.target.value;
	const activeElement = document.activeElement;
 
		if ( activeElement && activeElement.id === 'txtPhone') {
		
		val=val.trim();
 this.setState({[nam]: val});

  if(event.keyCode === 13) {
	if(val.length<10)
	{
		 this.setState({open: true,errormessage:'Please Enter Valid Phone No.'});
		 return false;
	}
axios.get(Serverurl+'ajaxparent.php?action=getall&pr_phonenumber='+val)
       .then(resp => { 		
			if(resp.data.length>0){
				 this.setState({redirect: true,pagename:'/Mystudents?pid='+resp.data[0]["pr_id"]});
			}
			else
			{
				this.setState({parentcnt:0});
			}
	   })
	
		}}
	 }
		handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }
	 render() {
	  
	 if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
	  
 const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      position: 'top',
    },
    title: {
      display: false,
      text: 'Attendance Overview',
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          return context.parsed.y + '%';
        },
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      max: 100,
      ticks: {
        stepSize: 10,
        callback: function (value) {
          return value + '%';
        },
      },
    },
  },
};


  return (
  
	 <React.Fragment> 
	 {this.state.parentcnt===0 && (
	 <ParentPassword phone={this.state.Phone}/>
	 )}
	 {this.state.parentcnt===1 && ( <React.Fragment> 
	 
	  <p>  <Collapse in={this.state.open}>
										<Alert
										  action={
											<IconButton
											  aria-label="close"
											  color="inherit"
											  size="small"
											  onClick={() => {
											   this.handleErrorclose();
											  }}
											>
											  <CloseIcon fontSize="inherit" />
											</IconButton>
										  } severity="error"
										>
										{this.state.errormessage}
										</Alert>
								</Collapse></p>
{localStorage.getItem("MMCrole")!=="1" &&( <React.Fragment> 

	 <div className="statssec-cnt1">
	 <div className="statsicon">
	 <img src={stats1} alt="MM Coaching" />
	 </div>
	  <div className="statstext">
	<p>Latest Attendance</p>
	<h2>{this.state.yesatdncecnt}</h2>
	   </div>
	 </div>
	  <div className="statssec-cnt1">
	   <div className="statsicon">
	 <img src={stats2} alt="MM Coaching" />
	 </div>
	  <div className="statstext">
	<p>Students</p>
	<h2>{this.state.studcnt}</h2>
	   </div>
	  </div>
	  
	  <div className="statssec-register"><div className="panelbox">
	  <div className="admitpad">
	  <h2><img src={RegisterIcon} /> Admission/Pay Fee</h2>
	  </div> </div>
	  <div className="admitpad">
	  
	  <p><TextField id="txtPhone" fullWidth type="Number" size="small"  placeholder="Phone No."  name="Phone" value={this.state.Phone}  inputProps={{tabIndex: "1",maxLength:15}} InputLabelProps={{ shrink: true }}  
	  onChange={this.escParentphFunction}
onFocus={this.escParentphFunction}
	  /></p>
			</div>
	   </div>
	   </React.Fragment>  )}
	 <div className="clear"></div>
{localStorage.getItem("MMCrole")==="1" &&( <React.Fragment> 
	 <div className="statssec-register">
	 
	
<div className="admitpad">
	 <p>Branch <FormControl  className="stadrp">
          <Select
         native  fullWidth
		 
		 
		 variant="outlined"
            margin="normal"
		 
          onChange={this.myChangeHandler}
          id="branchid"
		   value={this.state.branchid}
		  name="branchid"
		
		
        >
		{this.state.Branchdata.map(brrows => (
            <option  
            
              value={brrows.value}
            >
              {brrows.display}
            </option  >
          ))}
		
        </Select>
       </FormControl>
		
			</p></div></div>
			<div className="clear"></div>
			
		 { this.state.studcountdata.length > 0 && (	 <React.Fragment> 
		 <div className="boxheading"><h2>Current Stats</h2></div>
		 
		 
		  <div className="statsadminsec-cnt1">  <div className="statstext">
		  <h2>{this.state.studcountdata[0].prcnt}</h2>
		  <p>Active Parents</p> </div>
	  </div>
		 {(this.state.studcountdata).map((rows,index) => {  
           return (

		  <div className="statsadminsec-cnt1">
	  
	  <div className="statstext">

	<h2>{rows.count}</h2>
	<p>{rows.tc_title}</p>
	   </div>
	  </div>
	 	 );
					})}
					 </React.Fragment>
		 )}
		 <div className="clear"></div>
			
			</React.Fragment>  )}
			
	 	 <div className="attandace-box">
		  <div className="boxheading">
	  <div className="admitpad">
	  <h2><img src={attndnceIcon} /> Attendance</h2>
	  </div> </div> <div className="admitpad alerts">
	  	
		  {this.state.dataarr.labels && this.state.dataarr.labels.length > 0 ? (
  <Bar data={this.state.dataarr} options={chartOptions} />
) : (
  <p>No attendance data available.</p>
)}
	  </div>
		 </div>
	 
	 <div className="statssec-alerts">
	 <div className="boxheading">
	  <div className="admitpad">
	  <h2><img src={AlertsIcon} /> Alerts</h2>
	  </div> </div>
	  <div className="admitpad alerts">
	 
	 <Paper >
  <TableContainer >  
                <Table stickyHeader aria-label="sticky table">  

					  
					  
                      <TableBody>
                     {(this.state.notifyarray).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >


<TableCell>
<div className="alertleft">
<a href={'#/Notificationview?noid='+item.no_id} >{item.date}</a>
</div><div className="alertright">
<a href={'#/Notificationview?noid='+item.no_id} >{item.no_title}</a>
</div><div className="clear"></div>
<span className="tabfont">for {item.title} {item.optiontype}</span>
</TableCell>

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.notifycnt===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="1">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[]}  
        component="div"  
        count={this.state.notifycnt}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />   
  </Paper>
	 
	 
	  </div>
	 </div>
<div className="clear"></div>	
{this.state.feebalance!==0 && (
<div className="dashboardfeebalance">
<div className="boxheading">
	  <div className="admitpad">
	  <h2><img src={payment} /> Fee Balance: Rs.{this.state.feebalance}</h2>
	  </div> </div>

</div>)}	 
	 </React.Fragment>   )}
	 <Topperlist />
	 </React.Fragment> 
	 )
	 }
}






